import { useEffect, useState, useCallback  } from 'react';
import { HeaderPage } from '../../components/Admin';

import { DialogBasic, ModalBasic } from '../../components/common';
import { useSnackbar } from 'notistack';
import { TableSales } from '../../components/Admin/Finance/TableSales';

import { AddEditSaleForm } from '../../components/Admin/Finance/forms/AddEditSaleForm';
import { useFinance } from '../../hook/useFinance';
import { PaymentsModal } from '../../components/Admin/Finance';
import { SalesFilters } from '../../components/Admin/Finance/SalesFilters';
import { useClients } from "../../hook/useClients"; // ajusta ruta según tu proyecto

export function SalesAdmin() {
  const { loading, sales, getSales, newSale, editSale, removeSale, addPayment } = useFinance();
  const { clients, getClients, newClient } = useClients();
  const { enqueueSnackbar } = useSnackbar();

  const [openDialog, setOpenDialog] = useState(false);
  const [idItem, setIdItem] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);

  const [paymentOpen, setPaymentOpen] = useState(false);
  const [activeSale, setActiveSale] = useState(null);

  const [params, setParams] = useState({ ordering: "-created_at" });

  useEffect(() => {
  getClients({ page_size: 200 }).catch(() => {});

  
}, []);


  const refreshSales = useCallback(async () => {
    await getSales(params);
  }, [getSales, params]);



  useEffect(() => { getSales(params); }, [params]); // fetch solo cuando cambie params
  const onFiltersChange = useCallback((next) => {
    setParams((prev) => {
      // evita setState si no cambió (opcional pero recomendado)
      const a = JSON.stringify(prev);
      const b = JSON.stringify(next);
      return a === b ? prev : next;
    });
  }, [setParams]);
  const openCloseModal = () => setShowModal(prev => !prev);

  const addSale = () => {
    setTitleModal('Nueva Venta');
    setContentModal(
      <AddEditSaleForm
          clients={clients}
          onCreateClient={newClient} // opcional, si quieres crearlo desde front; si no, usa client_create en sale
          onClose={openCloseModal}
          onSuccess={async () => {
            enqueueSnackbar('Venta creada', { variant: 'success' });
            await refreshSales();
          }}
          onSubmit={newSale}
        />
    );
    openCloseModal();
  };

  const editSaleHandler = (data) => {
    setTitleModal('Editar Venta');
    setContentModal(
      <AddEditSaleForm
        sale={data}
        onClose={openCloseModal}
        onSuccess={() => {  enqueueSnackbar('Venta actualizada', { variant: 'success' }); }}
      
        onSubmit={(payload) => editSale(data.id, payload)}
      />
    );
    openCloseModal();
  };

  const onDeleteSale = (data) => {
    setIdItem(data.id);
    setOpenDialog(true);
  };

  const handleCloseDialog = async (confirmed) => {
    if (confirmed) {
      try {
        await removeSale(idItem);
        enqueueSnackbar('Venta eliminada', { variant: 'success' });
        await getSales(params); // ✅ refresca

        
        
      } catch (err) {
        enqueueSnackbar('Error eliminando venta', { variant: 'error' });
      } finally {
        setOpenDialog(false);
      }
    } else {
      setOpenDialog(false);
    }
  };

  const onViewPayments = (sale) => {
    setActiveSale(sale);
    setPaymentOpen(true);
  };

  return (
    <>
      <HeaderPage title="Ventas" btnClick={addSale} />
      <SalesFilters onChange={onFiltersChange} />

      {loading ? (
        <p>Cargando...</p>
      ) : (
        <TableSales
          sales={sales}
          editSale={editSaleHandler}
          onDeleteSale={onDeleteSale}
          onViewPayments={onViewPayments}
        />
      )}

      <ModalBasic
        show={showModal}
        onClose={openCloseModal}
        title={titleModal}
        size={'medium'}
      >
        {contentModal}
      </ModalBasic>

      <DialogBasic open={openDialog} onClose={handleCloseDialog} />

      <PaymentsModal
        open={paymentOpen}
        sale={activeSale}      
        onClose={() => setPaymentOpen(false)}
        onAdd={async (payload) => {
          try {
            await addPayment(activeSale.id, payload);
            enqueueSnackbar('Pago registrado', { variant: 'success' });
            await getSales(params); // ✅ refresca
            
          } catch (err) {
            enqueueSnackbar(err?.non_field_errors?.[0] || 'Error registrando pago', { variant: 'error' });
          }
        }}
      />
    </>
  );
}
